import React from 'react';
import Lot from "./components/exhibtionDetails"
import Banner from './components/banner'
function view(props) { 
    return (
        <div style={{paddingTop: 5}}>
          <Banner param={props.param}/>
          <Lot/>
        </div>
    );
}

export default view;